<template>
<div class="phone" :class="{'mb': wayType==='m-phone'}">
    <phone-input v-show="regType === 'input'" @inputPhone="inputPhoneHandle" :wayType="wayType" />

    <phone-login v-show="regType === 'login'" @showForget="showForgetHandle" @success="successHandle" :wayType="wayType" :name="phone" :itc="itc" />

    <phone-reg v-show="regType === 'reg'" @success="successHandle" @inputPhone="inputPhoneHandle" :wayType="wayType" :name="phone" :itc="itc" />
</div>
</template>
<script>

import phoneInput from './phone/phone';
import phoneLogin from './phone/login';
import phoneReg from './phone/reg';

export default {
    name: 'phonewrap',
    props: {
        wayType: { type: String, default: '' }
    },
    data() {
        return {
            phone: '',
            itc: '',
            regType: 'input'
        };
    },
    components: {
        'phone-input': phoneInput,
        'phone-login': phoneLogin,
        'phone-reg': phoneReg
    },

    computed: {
        componentState() {
            return (this.wayType === 'phone' && this.regType === '') ? 'input' : this.regType;
        }
    },

    methods: {
        showForgetHandle(type, name, itc) {
            this.$emit('showForget', type, name, itc);
        },
        successHandle(data) {
            this.$emit('success', data);
        },
        inputPhoneHandle(type, name, itc) {
            this.regType = type;
            this.phone = name;
            this.itc = itc;
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
.phone {
    position: relative;
    padding-top: 30px;
    box-sizing: border-box;
    &.mb {
        padding-top: 0;
    }
    // @media screen and (max-width: 720px) {
    //     position: relative;
    //     padding-top: 0;
    // }
}
</style>
